import { useState } from 'react';
import { NavLink } from 'react-router-dom';

import S from './SideMenuStyles';
import Icon from '../../common/Icon/Icon';
import { IconKeys } from '../../common/Icon/IconKeys';
import useGetRole from '../../../API/hooks/useGetRole';
import { FeaturesManagement } from '../../../featuresControl';
import { useAppTheme } from '../../../theme/ThemeContext';

const baseLinkClass = 'menu-link row ai-center';

function SideMenu(): JSX.Element {
  const [open, setOpen] = useState(true);
  const handleSetOpen = (): void => { setOpen(!open); };

  const { isFleetViewer } = useGetRole();
  const { themeMode } = useAppTheme();
  const logoIconKey = themeMode === 'light' ? IconKeys.LOGO_LIGHT : IconKeys.LOGO;

  const mainNavItems = [{
    label: 'Dashboard',
    iconKey: IconKeys.HOME,
    to: '/home',
    show: true,
  }, {
    label: 'Alerts',
    iconKey: IconKeys.LIGHTNING,
    to: '/alerts',
    badge: false,
    show: true,
  }, {
    label: 'Drivers',
    iconKey: IconKeys.USERS,
    to: '/drivers',
    show: true,
  }, {
    label: 'Vehicles',
    iconKey: IconKeys.CAR,
    to: '/vehicles',
    show: true,
  }, {
    label: 'Devices',
    iconKey: IconKeys.PHOTO,
    to: '/devices',
    show: true,
  }, {
    label: 'Trips',
    iconKey: IconKeys.TRIPS,
    to: '/trips',
    show: true,
  }, {
    label: 'Videos',
    iconKey: IconKeys.VIDEO,
    to: '/videos',
    show: true,
  }, {
    label: 'Users',
    iconKey: IconKeys.USER_MANAGEMENT,
    to: '/management',
    show: FeaturesManagement.features.userManagement,
  }, {
    label: 'Announcement',
    iconKey: IconKeys.ANNOUNCEMENT,
    to: '/announcements',
    show: !isFleetViewer,
  }, {
    label: 'Geofences',
    iconKey: IconKeys.GEOFENCE,
    to: '/geofences',
    show: !isFleetViewer && FeaturesManagement.features.geofence,
  },
  ];

  const subNavItems = [{
    label: 'Add',
    iconKey: IconKeys.PLUS,
    to: '/add',
    // TODO enable after implementation
    show: false,
  }, {
    label: 'Suitcase',
    iconKey: IconKeys.SUITCASE,
    to: '/portfolio',
    // TODO enable after implementation
    show: false,
  }, {
    label: 'Question',
    iconKey: IconKeys.QUESTION,
    to: '/help',
    // TODO enable after implementation
    show: false,
  }, {
    label: 'Settings',
    iconKey: IconKeys.SETTINGS,
    to: '/settings',
    show: !(isFleetViewer),
  }];

  return (
    <S.Wrapper className={`${open ? 'open' : ''}`}>
      <div className="logo"><Icon iconKey={logoIconKey} /></div>
      <nav className="nav-container">
        <ul className="nav-list">
          {mainNavItems.map((item): JSX.Element => (
            <NavLink
              key={item.label}
              to={item.to}
              className={`${baseLinkClass}${!item.show ? ' hidden-item' : ''}`}
            >
              <div className="icon-badge">
                <Icon iconKey={item.iconKey} />
                {item.badge && <div className="badge" />}
              </div>
              <span className="label">{item.label}</span>
            </NavLink>
          ))}
        </ul>
        <ul className="sub-nav">
          {subNavItems.map((item): JSX.Element => (
            <NavLink
              key={item.label}
              to={item.to}
              className={`${baseLinkClass}${!item.show ? ' hidden-item' : ''}`}
            >
              <Icon iconKey={item.iconKey} />
              <span className="label">{item.label}</span>
            </NavLink>
          ))}
          <div
            role="presentation"
            className={`${baseLinkClass} arrow`}
            onClick={handleSetOpen}
          >
            <Icon iconKey={open ? IconKeys.ROUNDED_ARROW_LEFT : IconKeys.ROUNDED_ARROW_RIGHT} />
          </div>
        </ul>
      </nav>
    </S.Wrapper>
  );
}

export default SideMenu;
